import { render, staticRenderFns } from "./fee-tax-manage.vue?vue&type=template&id=6a653cfe"
import script from "./fee-tax-manage.vue?vue&type=script&lang=js"
export * from "./fee-tax-manage.vue?vue&type=script&lang=js"
import style0 from "./fee-tax-manage.vue?vue&type=style&index=0&id=6a653cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports